import React, { Component } from 'react'
import { observer } from 'mobx-react'
import { List, Avatar, Tabs, Spin } from 'hljd'
import style from './style.module.less'
import Store from './store'
import { dGet } from '@core/utils'
import { statistic } from '@util'
import { STATISTIC_COMMERCIAL_SCHOOL } from '@constant'
import cls from 'classnames'
import auth, { BUSINESS_COLLEGE } from '../auth'

const TabPane = Tabs.TabPane

/** 商学院 */
@auth(BUSINESS_COLLEGE)
@observer
export default class extends Component {
  constructor(props) {
    super(props)

    this.store = new Store()
    this.store.init()
  }

  render() {
    const { eSchoolList, loadMore, hasMore, types, spinning } = this.store
    const hasContent = eSchoolList.length > 0

    return types && types.length > 0 ? (
      <div className={style.panel}>
        <Tabs
          defaultActiveKey={types[0] && types[0].id}
          onChange={this.store.changeType}
          animated={{ inkBar: false, tabPane: false }}
        >
          {types.map((tap, index) => {
            return (
              <TabPane tab={tap.title} key={tap.type}>
                <Spin spinning={spinning} delay={300}>
                  <List
                    className={style.list}
                    itemLayout="horizontal"
                    dataSource={eSchoolList}
                    renderItem={(item, index) => {
                      const {
                        category_title,
                        type,
                        title,
                        list_img,
                        list_video,
                        sub_title,
                        id,
                        created_at
                      } = item

                      return (
                        <List.Item
                          onClick={() => {
                            if (index <= 4) {
                              statistic(STATISTIC_COMMERCIAL_SCHOOL, 'click', {
                                id
                              })
                            }
                            window.open(`#/localMerchant/businessSchool/${id}`)
                          }}
                          style={{ cursor: 'pointer' }}
                        >
                          <List.Item.Meta
                            avatar={
                              <div className={style.avatar}>
                                <Avatar src={list_img} />
                                {tap.type === 0 && (
                                  <div
                                    className={style.tag}
                                    style={{
                                      backgroundColor: {
                                        '1': '#60b0fd',
                                        '2': '#ffaa46',
                                        '3': '#49c77b',
                                        '4': '#b7a3ff'
                                      }[String(type)]
                                    }}
                                  >
                                    {category_title}
                                  </div>
                                )}

                                {list_video &&
                                  list_video.path && (
                                    <img
                                      className="center"
                                      src="//qnm.hunliji.com/o_1co76cqb317351jforthpbn1aib9.png"
                                    />
                                  )}
                              </div>
                            }
                            title={
                              <div className={cls('text-cut', style.title)}>
                                {title}
                              </div>
                            }
                            description={
                              <div>
                                <p
                                  className={style.subTitle}
                                  dangerouslySetInnerHTML={{
                                    __html: (sub_title || '').replace(
                                      /\n/g,
                                      '<br/>'
                                    )
                                  }}
                                />
                                <p className={style.date}>
                                  <span>
                                    {(created_at || '').split(' ')[0]}
                                  </span>
                                  <span>
                                    <img
                                      src="//qnm.hunliji.com/o_1coa8j3221gj5kojjl1put1p0j17.png"
                                      style={{ marginRight: 8 }}
                                    />
                                    <span className={style.count}>
                                      {dGet(item, 'watch_count', 0)}
                                    </span>
                                  </span>
                                </p>
                              </div>
                            }
                          />
                        </List.Item>
                      )
                    }}
                  />
                  {hasContent &&
                    hasMore && (
                      <div className="text-center" style={{ marginBottom: 20 }}>
                        <a onClick={loadMore}>加载更多</a>
                      </div>
                    )}
                </Spin>
              </TabPane>
            )
          })}
        </Tabs>
      </div>
    ) : null
  }
}
